// src/App.tsx
import React from 'react';
import { useLocation, Routes, Route } from 'react-router-dom'; // Adjust imports
import { useThemeStore } from './shared/store/themeStore';
import Header from './shared/components/Header/Header';
import SpotlightOverlay from './shared/components/SpotlightOverlay';
import HomeScreen from './features/home/screens/HomeScreen';
import ProjectsScreen from './features/projects/screens/ProjectsScreen';
import ContactScreen from './features/contact/screens/ContactScreen';
import MenuPage from './features/menu/screens/MenuPage';
import './App.scss';

import { AnimatePresence } from 'framer-motion';
import { ActiveSectionProvider } from './shared/context/ActiveSectionContext';
import ProjectDetailScreen from './features/projects/screens/ProjectDetailScreen';

const App: React.FC = () => {
  const theme = useThemeStore((state) => state.theme);

  return (
    <div className={`app ${theme}`} data-theme={theme}>
      <ActiveSectionProvider>
        <SpotlightOverlay />
        <Header />
        <AppContent />
      </ActiveSectionProvider>
    </div>
  );
};

const AppContent: React.FC = () => {
  const location = useLocation();

  return (
    <div className="app-content">
      <AnimatePresence initial={false}>
        <Routes location={location}>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/projects" element={<ProjectsScreen />} />
          <Route path="/projects/:id" element={<ProjectDetailScreen />} />
          <Route path="/contact" element={<ContactScreen />} />
          <Route path="/menu" element={<MenuPage />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
};

export default App;